import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const TopBtn = styled(Button)`
  overflow: hidden;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('36')};
    height: ${mixin.pxToVw('36')};
    border-radius: ${mixin.pxToVw('6')};
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 44px;
    height: 44px;
    border-radius: 7px;
  }
`;
